// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAuYz9qB19riYcAOuwHMR9U-YgEyLE-Z-s",
  authDomain: "devs-united-fff3e.firebaseapp.com",
  projectId: "devs-united-fff3e",
  storageBucket: "devs-united-fff3e.appspot.com",
  messagingSenderId: "417215007527",
  appId: "1:417215007527:web:ab636bf066a74f3e643702"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);